import React from 'react';

/**
 * 품목 테이블 컴포넌트 (화면/문서 공용)
 * 
 * @param {Object} props
 * @param {Array} props.breakdown - 품목 배열 [{ name, unitPrice, quantity, subtotal }]
 * @param {Object} props.totals - { totalExclVAT, totalInclVAT }
 * @param {'screen'|'document'} props.mode - 렌더링 모드
 * @param {Object} props.simulatedQuantities - 시뮬레이션 수량 (screen 모드)
 * @param {Function} props.onQuantityChange - 수량 변경 핸들러 (screen 모드)
 * @param {boolean} props.isUnlocked - 잠금 해제 여부 (screen 모드)
 */
const BreakdownTable = ({
    breakdown = [],
    totals = { totalExclVAT: 0, totalInclVAT: 0 },
    mode = 'screen',
    simulatedQuantities = {},
    onQuantityChange,
    isUnlocked = false
}) => {
    const isDocument = mode === 'document';
    const { totalExclVAT, totalInclVAT } = totals;

    const handleQuantityChange = (idx, value) => {
        if (onQuantityChange) {
            onQuantityChange(idx, value);
        }
    };

    // 테이블 스타일 (모드에 따라 다름)
    const tableStyle = isDocument
        ? { width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }
        : { width: '100%', borderCollapse: 'collapse', marginTop: '10px' };

    const headerStyle = isDocument
        ? { background: '#f0f0f0', borderBottom: '2px solid #333' }
        : { background: '#f5f5f5', borderBottom: '2px solid #ddd' };

    return (
        <table className="ae-table breakdown-table" style={tableStyle}>
            <thead>
                <tr style={headerStyle}>
                    <th style={{ padding: '10px', textAlign: 'left' }}>품명</th>
                    <th style={{ padding: '10px', textAlign: 'right' }}>단가</th>
                    <th style={{ padding: '10px', textAlign: 'center', width: '80px' }}>수량</th>
                    <th style={{ padding: '10px', textAlign: 'right' }}>합계</th>
                </tr>
            </thead>
            <tbody>
                {breakdown.map((item, idx) => {
                    const displayQty = simulatedQuantities[idx] ?? item.quantity;
                    const displaySubtotal = item.unitPrice * displayQty;

                    return (
                        <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                            <td style={{ padding: '10px' }}>{item.name}</td>
                            <td style={{ padding: '10px', textAlign: 'right' }}>
                                {item.unitPrice.toLocaleString()}원
                            </td>
                            <td style={{ padding: '10px', textAlign: 'center' }}>
                                {/* Screen 모드: 수량 조절 가능 */}
                                {!isDocument && isUnlocked ? (
                                    <div className="sim-qty-control">
                                        <button
                                            className="sim-btn minus"
                                            onClick={() => handleQuantityChange(idx, displayQty - 1)}
                                        >
                                            -
                                        </button>
                                        <input
                                            type="number"
                                            min="0"
                                            className="sim-input"
                                            value={displayQty}
                                            onChange={(e) => handleQuantityChange(idx, e.target.value)}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                        <button
                                            className="sim-btn plus"
                                            onClick={() => handleQuantityChange(idx, displayQty + 1)}
                                        >
                                            +
                                        </button>
                                    </div>
                                ) : (
                                    displayQty
                                )}
                            </td>
                            <td className="num-cell" style={{ padding: '10px', textAlign: 'right' }}>
                                {displaySubtotal.toLocaleString()}원
                            </td>
                        </tr>
                    );
                })}
            </tbody>
            <tfoot>
                <tr style={{ fontWeight: 'bold', background: '#fafafa', borderTop: '2px solid #333' }}>
                    <td colSpan="3" style={{ padding: '10px' }}>총합계 (VAT 별도)</td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>{totalExclVAT.toLocaleString()}원</td>
                </tr>
                <tr style={{ background: isDocument ? '#f5f5f5' : '#e3f2fd' }}>
                    <td colSpan="3" style={{ padding: '10px', fontWeight: 'bold' }}>VAT 포함 금액</td>
                    <td style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold', color: isDocument ? '#000' : '#1565c0' }}>
                        {totalInclVAT.toLocaleString()}원
                    </td>
                </tr>
            </tfoot>
        </table>
    );
};

export default BreakdownTable;
